var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLossIcon = function SvgLossIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 121,
    viewBox: "0 0 118 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3627 21.2872C52.1232 19.1321 50.2077 17.2166 47.8132 17.2166C45.4187 17.2166 43.5031 18.8927 43.2637 21.2872V61.9933H52.3627V21.2872Z",
    fill: "#0D8426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4486 14.3431C67.2092 12.188 65.2936 10.2725 62.8991 10.2725C60.5046 10.2725 58.5891 11.9486 58.3496 14.3431V61.9931H67.4486V14.3431Z",
    fill: "#0D8426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7728 24.8799C82.5334 22.7249 80.6178 20.8093 78.2233 20.8093C75.8289 20.8093 73.9133 22.4855 73.6738 24.8799V61.7549H82.7728V24.8799Z",
    fill: "#0D8426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0965 33.9764C97.8571 31.8213 95.9415 29.9058 93.547 29.9058C91.1525 29.9058 89.2369 31.5819 88.9975 33.9764V75.6402C88.9975 90.2466 77.0251 102.219 62.4188 102.219C53.0804 102.219 44.2208 97.1905 39.4318 89.0493L25.7833 61.7523C24.5861 59.3578 21.7127 58.4 19.5577 59.5973C17.1632 60.7945 16.4449 63.4284 17.4027 65.8229L31.5301 93.3594L31.7695 93.5988C38.2346 104.613 49.9675 111.318 62.6583 111.318C82.293 111.318 98.336 95.2749 98.336 75.6402L98.0965 33.9764Z",
    fill: "#0D8426"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.5 51.9375L22.4302 99.5876L111.026 51.9375H9.5Z",
    fill: "#0D8426"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLossIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "loss-icon.0379d510e9f8fd1ac246010efd41b839.svg";